import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import PageNotFound from '@/views/PageNotFound.vue';
import initializeStore from '@/router/initializeStore';
import AuthGuard from '@/router/Guards/AuthGuard';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login/Login.vue'),
    meta: {
      auth: false,
    },
  },
  {
    path: '/wachtwoord-instellen',
    name: 'reset-password',
    component: () => import(/* webpackChunkName: "reset-password" */ '@/views/ResetPassword/ResetPassword.vue'),
    meta: {
      auth: false,
    },
  },
  {
    path: '/mfa-instellen',
    name: 'reset-mfa',
    component: () => import(/* webpackChunkName: "reset-password" */ '@/views/ResetMfa/ResetMfa.vue'),
    meta: {
      auth: false,
    },
  },
  {
    path: '/rapportage',
    name: 'rapportage',
    component: () => import(/* webpackChunkName: "rapportage" */ '@/views/Rapportage/Rapportage.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/reports',
    name: 'report',
    component: () => import(/* webpackChunkName: "reports" */ '@/views/Reports/Reports.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/reports/:id',
    name: 'report.detail',
    component: () => import(/* webpackChunkName: "report" */ '@/views/Reports/Report.vue'),
    meta: {
      auth: true,
    },
    children: [
      {
        name: 'report.detail.damages',
        path: 'damages',
        component: () => import(/* webpackChunkName: "report-tab-damages" */ '@/views/Reports/Damages/Damages.vue'),
        meta: {
          auth: true,
        },
      },
      {
        name: 'report.detail.communication',
        path: 'communication',
        component: () => import(/* webpackChunkName: "report-tab-communicatie" */ '@/views/Reports/Communication/Communication.vue'),
        meta: {
          auth: true,
        },
      },
      {
        name: 'report.detail.attachments',
        path: 'attachments',
        component: () => import(/* webpackChunkName: "report-tab-attachments" */ '@/views/Reports/Attachments/Attachments.vue'),
        meta: {
          auth: true,
        },
      },
      {
        name: 'report.detail.instructions',
        path: 'instructions',
        component: () => import(/* webpackChunkName: "report-tab-instructions" */ '@/views/Reports/Instructions/Instructions.vue'),
        meta: {
          auth: true,
        },
      },
      {
        name: 'report.detail.feedback',
        path: 'feedback',
        component: () => import(/* webpackChunkName: "report-tab-instructions" */ '@/views/Reports/Feedback/Feedback.vue'),
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    path: '/reports/:id/contract',
    name: 'contract',
    component: () => import(/* webpackChunkName: "contract" */ '@/views/Contracts/Contract.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/contractors',
    name: 'contractor',
    component: () => import(/* webpackChunkName: "contractors" */ '@/views/Contractors/Contractors.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/contractors/:id',
    name: 'contractor.detail',
    component: () => import(/* webpackChunkName: "contractor" */ '@/views/Contractors/Contractor.vue'),
    meta: {
      auth: true,
    },
    children: [
      {
        name: 'contractor.detail.planning',
        path: 'planning',
        component: () => import(/* webpackChunkName: "contractor-detail-planning" */ '@/views/Contractors/Planning/Planning.vue'),
        meta: {
          auth: true,
        },
      },
      {
        name: 'contractor.detail.feedback',
        path: 'feedback',
        component: () => import(/* webpackChunkName: "contractor-detail-feedback" */ '@/views/Contractors/Feedback/Feedback.vue'),
        meta: {
          auth: true,
        },
      },
      {
        name: 'contractor.detail.users',
        path: 'users',
        component: () => import(/* webpackChunkName: "contractor-detail-users" */ '@/views/Contractors/Users/Users.vue'),
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    path: '/users/:id',
    name: 'user.detail',
    component: () => import(/* webpackChunkName: "user" */ '@/views/Users/User.vue'),
    meta: {
      auth: true,
    },
    children: [
      {
        name: 'user.detail.actions',
        path: 'actions',
        component: () => import(/* webpackChunkName: "user-detail-actions" */ '@/views/Users/UserActions/UserActions.vue'),
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    path: '/library',
    name: 'library',
    component: () => import(/* webpackChunkName: "library" */ '@/views/Library/Library.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '*',
    name: 'errors.404',
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.path !== '/') {
    await AuthGuard(to, from, next);
    await initializeStore(to, from, next);
  }

  next();
});

export default router;
